export const EMembershipStatus = {
  Joined: "JOINED",
  Expired: "EXPIRED",
} as const;

export type EMembershipStatus =
  (typeof EMembershipStatus)[keyof typeof EMembershipStatus];
